/**
 * UI presentation for the four moderation modes: labels, images, and the
 * dropdown's option list.
 *
 * The silo's settings singleton lists which modes it permits in its
 * `moderationMode` field; a space carries the one it runs in its own
 * `moderationMode` field, read and written through `spaces.*`. Both validate
 * against the `ModerationMode` enum in `@repo/shared/moderation-modes`, which
 * also owns the UI ordering, the default-mode pick, and the translation to and
 * from the per-instance feature flags the server stores the mode as.
 */

import { MODERATION_MODE_UI_ORDER, ModerationMode } from '@repo/shared/moderation-modes';

import { type TLabel, t } from './stdtypes';

export const aiModerationLabel = t('moderation.mode_ai', 'AI Moderation');
export const aiAndManualModerationLabel = t('moderation.mode_ai_and_manual', 'AI and Manual Moderation');
export const manualModerationLabel = t('moderation.mode_manual', 'Manual Moderation');
export const aiModerationWithPostAnywayLabel = t('moderation.mode_ai_post_anyway', 'AI Moderation with Post Anyway');

const moderationModeLabels: Record<ModerationMode, TLabel> = {
    [ModerationMode.AI_MODERATION]: aiModerationLabel,
    [ModerationMode.AI_MODERATION_WITH_POST_ANYWAY]: aiModerationWithPostAnywayLabel,
    [ModerationMode.MANUAL_MODERATION]: manualModerationLabel,
    [ModerationMode.AI_AND_MANUAL_MODERATION]: aiAndManualModerationLabel,
};

/**
 * The dropdown's options. Ordering comes from `MODERATION_MODE_UI_ORDER` in
 * shared, which the default-mode pick uses too, so the two can't drift.
 */
export const moderationModeOptions: { key: ModerationMode; label: TLabel }[] = MODERATION_MODE_UI_ORDER.map((key) => ({
    key,
    label: moderationModeLabels[key],
}));

export const moderationModeImages: Record<ModerationMode, string> = {
    [ModerationMode.AI_MODERATION]: '/images/ai-moderation.svg',
    [ModerationMode.AI_AND_MANUAL_MODERATION]: '/images/manual-moderation.svg',
    [ModerationMode.MANUAL_MODERATION]: '/images/manual-moderation.svg',
    [ModerationMode.AI_MODERATION_WITH_POST_ANYWAY]: '/images/ai-moderation-post-anyway.svg',
};
